//---------------------------------REACT-------------------------------------//
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

//---------------------------------MATERIAL UI-------------------------------------//
import { Grid, Container, LinearProgress } from "@mui/material";

//---------------------------------COMPONENTS-------------------------------------//
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import RequestCard from "../../components/RequestCard/RequestCard";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";

//---------------------------------THIRD PARTY-------------------------------------//
import { useTranslation } from "react-i18next";
import ls from "local-storage";

//---------------------------------ACTIONS-------------------------------------//
import { getTaskList, getStatusList } from "../../store/actions/AutonomousMaintenanceListActions";
import { getMaintenanceType } from "../../store/actions/AMActions";
import { getTechList } from "../../store/actions/breakDownTasksActions";

//---------------------------------STYLES-------------------------------------//
import { StyledGridUl, StyledListItem } from "../BreakdownList/styled";

//---------------------------------UTILS-------------------------------------//
import { getTitle } from "../../common";
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollTop from "react-scrolltop-button";
import { ArrowDropUp } from "@mui/icons-material";
import { isMobile } from "react-device-detect";

const ss = sessionStorage;
const constants = {
    dataSize: isMobile ? 5 : window.matchMedia("(orientation: portrait)").matches ? 30 : 15,
};

export default function AutonomousMaintenanceList(props) {
    const dispatch = useDispatch();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [userID, setUserID] = useState();
    const [userData, setUserData] = useState([]);
    const { t } = useTranslation("translation");
    const { techList } = useSelector(({ breakDownTask }) => breakDownTask);
    const { am } = useSelector((am) => am);
    const [rows, setRows] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const GetFirstDayOfWeek = () => {
        var curr = new Date(); // get current date
        var first = curr.getDate() - curr.getDay() + 1;
        return new Date(curr.setDate(first));
    };

    const GetLastDayOfWeek = () => {
        var curr = new Date(); // get current date
        var first = curr.getDate() - curr.getDay() + 1;
        return new Date(curr.setDate(first + 6));
    };

    //set current date
    const setCurrentDate = (date) => {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var modifiedMonth = month <= 9 ? "0" + month : month;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var newStartDate = year + "-" + modifiedMonth + "-" + day;
        return newStartDate;
    };

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserID(oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", ""));

        dispatch(getStatusList());
        dispatch(getMaintenanceType());
        dispatch(getTechList());
        LoadHandler();
        // Set time interval, if time range is not null, if it is null,set it to TODAY.
        ls.get("aml_plannedTimeRange") != null ? setSelectedTimeInterval(ls.get("aml_plannedTimeRange")) : setSelectedTimeInterval(1);
    }, []);

    const { tasklist, statusList } = useSelector(({ AutonomousMaintenanceList }) => AutonomousMaintenanceList);

    useEffect(() => {
        if (tasklist?.firstCallRes) {
            setRows(Object.values(tasklist.firstCallRes.resultObject.content));
            setHasMore(tasklist.firstCallRes.resultObject.hasNext);
            setPageLoaded(true);
            setCurrentPage(currentPage + 1);
        }

        if (tasklist?.fetchMoreDataRes) {
            const totalRows = [...rows, ...tasklist.fetchMoreDataRes.resultObject.content];
            setRows(totalRows);

            const hasNextPage = tasklist.fetchMoreDataRes.resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(currentPage + 1);
            }
        }
        if (tasklist?.applyFilterRes) {
            setRows(Object.values(tasklist.applyFilterRes.resultObject.content));
            if (tasklist.applyFilterRes.resultObject.hasNext) {
                setHasMore(tasklist.applyFilterRes.resultObject.hasNext);
                setCurrentPage(2);
            }
        }
    }, [tasklist]);

    useEffect(() => {
        if (statusList?.resultObject) {
            setStatusData(Object.values(statusList.resultObject));
            HandleStatusName(Object.values(statusList.resultObject), state.status);
        }
    }, [statusList]);

    useEffect(() => {
        if (am?.maintenanceType?.errorCode === 0) {
            setMaintenanceTypes(am?.maintenanceType?.resultObject);
        }
    }, [am]);

    useEffect(() => {
        if (techList.data != null && techList.data.length > 0) {
            setUserData(techList.data);
        }
    }, [techList]);

    let timeIntervals = [
        { id: 1, name: t("Today") },
        { id: 2, name: t("ThisWeek") },
        { id: 3, name: t("ThisMonth") },
        { id: 4, name: t("Manual") },
    ];
    let [selectedTimeInterval, setSelectedTimeInterval] = useState(0);

    // State
    const [state, setState] = useState({
        checkedMe: false,
        status: ls.get("aml_status") || [],
        startDate: ls.get("aml_startDate") || GetFirstDayOfWeek(),
        endDate: ls.get("aml_endDate") || GetLastDayOfWeek(),
    });

    const GetStatusArrayAsString = (arr) => {
        var statusArray = "";
        arr.forEach((element) => {
            statusArray += element + ",";
        });
        statusArray = statusArray.slice(0, -1);
        return statusArray;
    };

    const LoadHandler = () => {
        const data = {
            statusArr: GetStatusArrayAsString(state.status),
            startDate: ls.get("aml_startDate") || GetFirstDayOfWeek(),
            endDate: ls.get("aml_endDate") || GetLastDayOfWeek(),
            assigneeId: ls.get("aml_assigneeId") ? parseInt(ls.get("aml_assigneeId")) : 0,
            areaGroupId: machineStates.selectedAreaCode ?? 0,
            machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            maintenanceTypeId: selectedMaintenanceTypeId ?? 0,
        };

        let payload = {
            data: data,
            currentPage: currentPage,
            pageSize: constants.dataSize,
            firstCall: true,
        };

        dispatch(getTaskList(payload));
    };

    const HandleApplyFilter = (filterCleared = false) => {
        setRows([]);
        setHasMore(false);
        const data = {
            statusArr: filterCleared ? GetStatusArrayAsString([]) : GetStatusArrayAsString(state.status),
            startDate: filterCleared ? setCurrentDate(new Date()) : ls.get("aml_startDate") || GetFirstDayOfWeek(),
            endDate: filterCleared ? setCurrentDate(new Date()) : ls.get("aml_endDate") || GetLastDayOfWeek(),
            assigneeId: ls.get("aml_assigneeId") ? parseInt(ls.get("aml_assigneeId")) : 0,
            areaGroupId: filterCleared ? 0 : machineStates.selectedAreaCode ?? 0,
            machineId: filterCleared ? 0 : machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            maintenanceTypeId: filterCleared ? 0 : selectedMaintenanceTypeId ?? 0,
        };

        let payload = {
            pageSize: constants.dataSize,
            currentPage: 1,
            data: data,
            applyFilter: true,
        };
        dispatch(getTaskList(payload));
    };

    const HandleClearFilter = () => {
        HandleClearMachineStates();
        setSelectedMaintenanceTypeId(0);
        setSelectedMaintenanceTypeName(null);
        setSelectedTimeInterval(1);
        setState({ ...state, checkedMe: false, status: [] });
        setSelectedStatusName([]);
        ls.remove("aml_assigneeId");
        ls.remove("checkedMeAutonomous");
        ls.remove("aml_status");
        ls.set("aml_startDate", setCurrentDate(new Date()));
        ls.set("aml_endDate", setCurrentDate(new Date()));
        ls.remove("aml_plannedTimeRange");
        HandleApplyFilter(true);
    };

    const FetchMoreData =  () => {
        if (hasMore) {
            const data = {
                statusArr: GetStatusArrayAsString(state.status),
                startDate: ls.get("aml_startDate") || GetFirstDayOfWeek(),
                endDate: ls.get("aml_endDate") || GetLastDayOfWeek(),
                assigneeId: ls.get("aml_assigneeId") ? parseInt(ls.get("aml_assigneeId")) : 0,
                areaGroupId: machineStates.selectedAreaCode ?? 0,
                machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
                maintenanceTypeId: selectedMaintenanceTypeId ?? 0,
            };
            let payload = {
                data: data,
                currentPage: currentPage,
                pageSize: constants.dataSize,
                fetchMoreData: true,
            };
            dispatch(getTaskList(payload));
        }
    };

    const HandleAssignToMe = (event) => {
        setState({ ...state, checkedMe: event.target.checked });
        ls.set("checkedMeAutonomous", event.target.checked);
        const userInfo = userData.filter((item) => item.userCode == userID);

        if (event.target.checked) {
            ls.set("aml_assigneeId", userInfo[0].id);
        } else {
            ls.remove("aml_assigneeId");
        }
        HandleApplyFilter();
        setCurrentPage(1);
    };

    const [statusData, setStatusData] = useState([]);
    let [selectedStatusName, setSelectedStatusName] = useState([]);

    // Set status array
    const HandleStatus = (event) => {
        ls.set("aml_status", event.target.value);
        setState({ ...state, status: event.target.value });
        HandleStatusName(statusData, event.target.value);
    };

    // Set status name
    const HandleStatusName = (rawArray, filterArray) => {
        const statusFiltered = rawArray.filter((el) => {
            return filterArray.some((f) => {
                return f === el.code;
            });
        });
        setSelectedStatusName(statusFiltered.map((item) => item.description));
    };

    // Set timeInterval
    const HandleTimeInterval = (e) => {
        setState({ ...state, plannedTimeRange: e.target.value });
        ls.set("aml_plannedTimeRange", e.target.value);
        setSelectedTimeInterval(e.target.value);
        HandleTimeSelection(e.target.value);
    };

    const SetDates = (start, end) => {
        setState({ ...state, startDate: start, endDate: end });
        ls.set("aml_startDate", setCurrentDate(start));
        ls.set("aml_endDate", setCurrentDate(end));
    };

    //set start date
    const HandleStartDate = (date) => {
        setState({ ...state, startDate: setCurrentDate(date) });
        ls.set("aml_startDate", setCurrentDate(date));
    };

    //set end date
    const HandleEndDate = (date) => {
        setState({ ...state, endDate: setCurrentDate(date) });
        ls.set("aml_endDate", setCurrentDate(date));
    };

    const HandleTimeSelection = (id) => {
        switch (id) {
            // Week
            case 2:
                SetDates(GetFirstDayOfWeek(), GetLastDayOfWeek());
                break;
            // Month
            case 3:
                var date = new Date();
                var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                lastDayOfMonth.setHours(23, 59, 59, 999);
                SetDates(firstDayOfMonth, lastDayOfMonth);
                break;
            //Day and Manual
            default:
                var start = new Date();
                start.setHours(0, 0, 0, 0);
                var end = new Date();
                end.setHours(23, 59, 59, 999);
                SetDates(start, end);
                break;
        }
    };

    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "aml",
            selectedAreaCode: isCleared ? null : ss.getItem("aml_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("aml_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("aml_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("aml_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("aml_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("aml_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("aml_selectedAreaCode");
        ss.removeItem("aml_selectedAreaName");
        ss.removeItem("aml_selectedMainEquipmentCode");
        ss.removeItem("aml_selectedMainEquipmentName");
        ss.removeItem("aml_selectedSubEquipmentCode");
        ss.removeItem("aml_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState(null);
    const [selectedMaintenanceTypeId, setSelectedMaintenanceTypeId] = useState(0);
    const handleMaintenanceTypeChange = (maintenanceId) => {
        const filteredType = maintenanceTypes.filter((item) => item.name.includes(maintenanceId));
        if (maintenanceId != null) {
            setSelectedMaintenanceTypeName(filteredType[0].name);
            setSelectedMaintenanceTypeId(filteredType[0].id);
            return filteredType[0].id;
        } else {
            setSelectedMaintenanceTypeName("");
            setSelectedMaintenanceTypeId(0);
        }
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setIsFilterDrawerOpen(open);
    };

    const filter = () => {
        return (
            <DetailFilter
                HandleAssignToMe={HandleAssignToMe}
                checkedMe={ls.get("checkedMeAutonomous") ? ls.get("checkedMeAutonomous") : state.checkedMe}
                HandleTimeInterval={HandleTimeInterval}
                selectedTimeInterval={selectedTimeInterval}
                timeIntervals={timeIntervals}
                HandleStatus={HandleStatus}
                statusData={statusData}
                status={state.status}
                selectedStatusName={selectedStatusName}
                HandleMaintenanceTypeChange={handleMaintenanceTypeChange}
                maintenanceTypes={maintenanceTypes}
                selectedMaintenanceTypeName={selectedMaintenanceTypeName}
                setMachineStates={setMachineStates}
                machineStates={machineStates}
                HandleStartDate={HandleStartDate}
                startDate={state.startDate}
                HandleEndDate={HandleEndDate}
                endDate={state.endDate}
            />
        );
    };

    return (
        <div>
            {getTitle(t("AutonomousMaintenanceTaskList"))}
            {pageLoaded === true ? (
                <Container id="aml_Container" style={{ marginTop: 20, paddingLeft: "0px", paddingRight: "0px" }}>
                    <FilterDrawer
                        open={isFilterDrawerOpen}
                        onOpen={toggleDrawer(true)}
                        onClose={toggleDrawer(false)}
                        HandleClearFilter={HandleClearFilter}
                        HandleApplyFilter={() => {
                            setIsFilterDrawerOpen(false);
                            HandleApplyFilter();
                        }}
                        detailFilter={filter()}
                    />
                    <FilterButton onClick={() => toggleDrawer(true)} />
                    <Grid id="aml_Grid_5">
                        <InfiniteScroll
                            id="aml_InfiniteScroll"
                            dataLength={rows.length} //This is important field to render the next data
                            next={FetchMoreData}
                            hasMore={hasMore}
                            loader={rows.length > 15 ? <LinearProgress id="aml_LinearProgress" /> : null}
                            endMessage={
                                rows.length == 0 ? (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("ThereIsNoRecord")}</b>
                                    </p>
                                ) : (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("YouHaveSeenItAll")}</b>
                                    </p>
                                )
                            }
                        >
                            <StyledGridUl rows rowLength={3} id="aml_StyledGridUl">
                                {rows.map((row, index) => {
                                    return (
                                        <StyledListItem id="aml_StyledListItem">
                                            <li id={`aml_li_${index}`} key={index} style={{ margin: "5px" }}>
                                                <RequestCard id="aml_rc" rows={[row]} isPlannedMaintenance={true} detail={false} page="AutonomousMaintenance" />
                                            </li>
                                        </StyledListItem>
                                    );
                                })}
                            </StyledGridUl>
                        </InfiniteScroll>
                    </Grid>
                </Container>
            ) : null}
            <ScrollTop
                text="▲"
                distance={100}
                breakpoint={2000}
                style={{ backgroundColor: "#BCC5C6", borderRadius: "20px", border: "2px", color: "black" }}
                speed={200}
                target={0}
                number={10}
                icon={<ArrowDropUp />}
            />
            <LoadingBackdrop id="aml_lbd" />
        </div>
    );
}
